module.exports = __webpack_public_path__ + "media/images/lalamove@2x-db76632d1b263696901424372152e8be.png";